/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M19 6L19 18M22 8V16M10 15C10 16.1046 9.10457 17 8 17C6.89543 17 6 16.1046 6 15C6 13.8954 6.89543 13 8 13C9.10457 13 10 13.8954 10 15ZM10 15V7L13 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="14"
				height="20"
				rx="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 8.4C16 6.15979 16 5.03969 15.564 4.18404C15.1805 3.43139 14.5686 2.81947 13.816 2.43597C12.9603 2 11.8402 2 9.6 2H8.4C6.15979 2 5.03969 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03969 2 6.15979 2 8.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03969 22 6.15979 22 8.4 22H9.6C11.8402 22 12.9603 22 13.816 21.564C14.5686 21.1805 15.1805 20.5686 15.564 19.816C16 18.9603 16 17.8402 16 15.6V8.4ZM8 17C9.10457 17 10 16.1046 10 15C10 13.8954 9.10457 13 8 13C6.89543 13 6 13.8954 6 15C6 16.1046 6.89543 17 8 17Z"
				fill="currentColor"
			/>
			<path
				d="M19 6V18M22 8V16M10 15C10 16.1046 9.10457 17 8 17C6.89543 17 6 16.1046 6 15C6 13.8954 6.89543 13 8 13C9.10457 13 10 13.8954 10 15ZM10 15L10 7L13 9M8.4 22H9.6C11.8402 22 12.9603 22 13.816 21.564C14.5686 21.1805 15.1805 20.5686 15.564 19.816C16 18.9603 16 17.8402 16 15.6V8.4C16 6.15979 16 5.03968 15.564 4.18404C15.1805 3.43139 14.5686 2.81947 13.816 2.43597C12.9603 2 11.8402 2 9.6 2H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.4 1.25H8.367H8.36699C7.27485 1.24999 6.40935 1.24999 5.71173 1.30699C4.99834 1.36527 4.39472 1.48688 3.84355 1.76772C2.94978 2.22312 2.22312 2.94978 1.76772 3.84355C1.48688 4.39472 1.36527 4.99834 1.30699 5.71173C1.24999 6.40936 1.24999 7.27486 1.25 8.367V8.4V15.6V15.633C1.24999 16.7251 1.24999 17.5906 1.30699 18.2883C1.36527 19.0017 1.48688 19.6053 1.76772 20.1565C2.22312 21.0502 2.94978 21.7769 3.84355 22.2323C4.39472 22.5131 4.99834 22.6347 5.71173 22.693C6.40935 22.75 7.27485 22.75 8.36698 22.75H8.4H9.6H9.63302C10.7252 22.75 11.5906 22.75 12.2883 22.693C13.0017 22.6347 13.6053 22.5131 14.1565 22.2323C15.0502 21.7769 15.7769 21.0502 16.2323 20.1565C16.5131 19.6053 16.6347 19.0017 16.693 18.2883C16.75 17.5907 16.75 16.7252 16.75 15.633V15.633V15.6V8.4V8.36698V8.36697C16.75 7.27484 16.75 6.40935 16.693 5.71173C16.6347 4.99834 16.5131 4.39472 16.2323 3.84355C15.7769 2.94978 15.0502 2.22312 14.1565 1.76772C13.6053 1.48688 13.0017 1.36527 12.2883 1.30699C11.5906 1.24999 10.7251 1.24999 9.633 1.25H9.6H8.4ZM19.75 6C19.75 5.58579 19.4142 5.25 19 5.25C18.5858 5.25 18.25 5.58579 18.25 6V18C18.25 18.4142 18.5858 18.75 19 18.75C19.4142 18.75 19.75 18.4142 19.75 18V6ZM22.75 8C22.75 7.58579 22.4142 7.25 22 7.25C21.5858 7.25 21.25 7.58579 21.25 8V16C21.25 16.4142 21.5858 16.75 22 16.75C22.4142 16.75 22.75 16.4142 22.75 16V8ZM9.64611 6.33875C9.88997 6.20823 10.1859 6.22254 10.416 6.37596L13.416 8.37596C13.7607 8.60573 13.8538 9.07138 13.624 9.41603C13.3943 9.76067 12.9286 9.8538 12.584 9.62404L10.75 8.40139V15C10.75 16.5188 9.51878 17.75 8 17.75C6.48122 17.75 5.25 16.5188 5.25 15C5.25 13.4812 6.48122 12.25 8 12.25C8.45011 12.25 8.87497 12.3581 9.25 12.5499V7C9.25 6.7234 9.40224 6.46926 9.64611 6.33875ZM9.25 15C9.25 14.3096 8.69036 13.75 8 13.75C7.30964 13.75 6.75 14.3096 6.75 15C6.75 15.6904 7.30964 16.25 8 16.25C8.69036 16.25 9.25 15.6904 9.25 15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 10V9.5V8.4C2 6.15979 2 5.03968 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C5.03968 2 6.15979 2 8.4 2H9.6C11.8402 2 12.9603 2 13.816 2.43597C14.5686 2.81947 15.1805 3.43139 15.564 4.18404C16 5.03968 16 6.15979 16 8.4V15.6C16 17.8402 16 18.9603 15.564 19.816C15.1805 20.5686 14.5686 21.1805 13.816 21.564C12.9603 22 11.8402 22 9.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V14.5V14M19 6V18M22 8V16M10 15C10 16.1046 9.10457 17 8 17C6.89543 17 6 16.1046 6 15C6 13.8954 6.89543 13 8 13C9.10457 13 10 13.8954 10 15ZM10 15V7L13 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M19 6V18M22 8V16M10 15C10 16.1046 9.10457 17 8 17C6.89543 17 6 16.1046 6 15C6 13.8954 6.89543 13 8 13C9.10457 13 10 13.8954 10 15ZM10 15V7L13 9M8.4 22H9.6C11.8402 22 12.9603 22 13.816 21.564C14.5686 21.1805 15.1805 20.5686 15.564 19.816C16 18.9603 16 17.8402 16 15.6V8.4C16 6.15979 16 5.03968 15.564 4.18404C15.1805 3.43139 14.5686 2.81947 13.816 2.43597C12.9603 2 11.8402 2 9.6 2H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M8.45 1.25C5.92976 1.25 4.66965 1.25 3.70704 1.74047C2.86031 2.1719 2.1719 2.86031 1.74047 3.70704C1.25 4.66965 1.25 5.92976 1.25 8.45V15.55C1.25 18.0702 1.25 19.3304 1.74047 20.293C2.1719 21.1397 2.86031 21.8281 3.70704 22.2595C4.66965 22.75 5.92976 22.75 8.45 22.75H9.55C12.0702 22.75 13.3304 22.75 14.293 22.2595C15.1397 21.8281 15.8281 21.1397 16.2595 20.293C16.75 19.3304 16.75 18.0702 16.75 15.55V8.45C16.75 5.92976 16.75 4.66965 16.2595 3.70704C15.8281 2.86031 15.1397 2.1719 14.293 1.74047C13.3304 1.25 12.0702 1.25 9.55 1.25H8.45Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19 5.25C19.4142 5.25 19.75 5.58579 19.75 6V18C19.75 18.4142 19.4142 18.75 19 18.75C18.5858 18.75 18.25 18.4142 18.25 18V6C18.25 5.58579 18.5858 5.25 19 5.25ZM9.64611 6.33874C9.88997 6.20823 10.1859 6.22253 10.416 6.37596L13.416 8.37596C13.7607 8.60573 13.8538 9.07138 13.624 9.41603C13.3943 9.76067 12.9286 9.8538 12.584 9.62404L10.75 8.40139V15C10.75 16.5188 9.51878 17.75 8 17.75C6.48122 17.75 5.25 16.5188 5.25 15C5.25 13.4812 6.48122 12.25 8 12.25C8.45011 12.25 8.87497 12.3581 9.25 12.5499V7C9.25 6.7234 9.40224 6.46926 9.64611 6.33874ZM9.25 15C9.25 14.3096 8.69036 13.75 8 13.75C7.30964 13.75 6.75 14.3096 6.75 15C6.75 15.6904 7.30964 16.25 8 16.25C8.69036 16.25 9.25 15.6904 9.25 15ZM22 7.25C22.4142 7.25 22.75 7.58579 22.75 8V16C22.75 16.4142 22.4142 16.75 22 16.75C21.5858 16.75 21.25 16.4142 21.25 16V8C21.25 7.58579 21.5858 7.25 22 7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
